module.exports = __webpack_public_path__ + "img/naologo2.35768aa7.png";